import { renderNextButton, renderPreviousButton, renderPaginationOptions } from "./render-pagination";
import { getTranslations } from "./get-translations";
import { performSearch } from "./search-hub";

export function setPaginationEvents(paginationElements, formControl, currentAbortController) {
    if (paginationElements.length > 0) {
        [...paginationElements].forEach(pagination => {
            setNavigationEvents(pagination, formControl, currentAbortController);
        })
    }
}

export function setNavigationEvents(navigationElement, formControl, currentAbortController) {
    if (navigationElement) {

        navigationElement.addEventListener("click", (e)=>{
            e.preventDefault();

            const pageTarget = navigationElement.dataset.pageTarget;

            if (formControl) {
                performSearch(pageTarget, formControl, currentAbortController);
            }
        })
    }
}

export async function updatePagination(paginationInfo, formControl, currentAbortController) {
    const paginationContainer = document.getElementById("paginationContainer");

    const translations = await getTranslations;

    paginationContainer.innerHTML = "";

    if (paginationInfo.totalPages > 1) {
        paginationContainer.innerHTML = `
        <div class="mt-5 flex w-full justify-center">
            <div class="inline-flex items-center gap-6 rounded-full border border-green-200 px-6 py-3 text-base font-bold">
                ${renderPreviousButton(paginationInfo, translations)}
                <ul class="pagination">
                    ${renderPaginationOptions(paginationInfo)}
                </ul>
                ${renderNextButton(paginationInfo, translations)}
            </div>
        </div>
        `;

        const previousPageElement = document.querySelector(".pagination-js-search-previous");
        const nextPageElement = document.querySelector(".pagination-js-search-next");

        setNavigationEvents(previousPageElement, formControl, currentAbortController);
        setNavigationEvents(nextPageElement, formControl, currentAbortController);

        const paginationElements = document.getElementsByClassName("pagination-js-search");
        setPaginationEvents(paginationElements, formControl, currentAbortController)
    }

}